










import { Vue, Component } from "vue-property-decorator";
import { $auth } from "@/services/AuthenticationService";
import AgAppBar from "@/components/AgAppBar.vue";
import AgAdminDrawer from "@/components/AgAdminDrawer.vue";
import AgMyDrawer from "@/components/AgMyDrawer.vue";

@Component({
  components: {
    AgAppBar,
    AgAdminDrawer,
    AgMyDrawer
  }
})
export default class Layout extends Vue {
  get currentUser() {
    return $auth.currentUser;
  }

  get isAdminPortal() {
    return this.$route.meta.prefix == "/admin";
  }
}
